<template lang="pug">
.site-config
  v-container
    v-row
      v-col(cols="12")
        v-card
          v-card-title.primary.white--text
            v-icon.mr-2(color="white") mdi-cog
            | Configuración del Sitio
          
          v-card-text.pt-4
            v-alert(
              v-if="success"
              type="success"
              dismissible
              transition="scale-transition"
            ) Configuración actualizada correctamente
            
            v-form(ref="form" @submit.prevent="saveConfig")
              v-switch(
                v-model="config.maintenanceMode"
                label="Modo Mantenimiento"
                color="primary"
                class="mb-4"
              )
              
              v-expand-transition
                div(v-if="config.maintenanceMode")
                  v-text-field(
                    v-model="config.previewToken"
                    label="Token de Vista Previa"
                    outlined
                    :append-icon="showToken ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="showToken ? 'text' : 'password'"
                    @click:append="showToken = !showToken"
                    class="mb-4"
                  )
                  
                  v-combobox(
                    v-model="config.allowedIPs"
                    label="IPs Permitidas"
                    outlined
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    class="mb-4"
                  )
                    template(v-slot:no-data)
                      v-list-item
                        v-list-item-content
                          span Ingresa una IP y presiona Enter

              // Sección Suscripción (un solo plan)
              v-divider.my-6
              v-card(flat class="mb-4")
                v-card-title.subtitle-1
                  v-icon.mr-2 mdi-cash-multiple
                  | Suscripción (Plan Único)
                v-card-text
                  v-row
                    v-col(cols="12" md="4")
                      v-text-field(
                        v-model.number="config.subscription.price"
                        type="number"
                        label="Precio mensual (ARS)"
                        prefix="$"
                        min="0"
                        outlined
                        :rules="[v => v >= 0 || 'Debe ser un valor positivo']"
                      )
                    v-col(cols="12" md="4")
                      v-select(
                        v-model="config.subscription.billingMode"
                        :items="billingModes"
                        item-text="text"
                        item-value="value"
                        label="Modalidad de cobro"
                        outlined
                      )
                    v-col(cols="12" md="4")
                      v-text-field(
                        v-model.number="config.subscription.graceMonths"
                        type="number"
                        min="0"
                        label="Período de gracia (meses)"
                        outlined
                      )
                  v-textarea(
                    v-model="config.subscription.invoiceNotes"
                    label="Notas de factura (opcional)"
                    rows="3"
                    outlined
                  )
              
              v-card-actions.pt-4
                v-spacer
                v-btn(
                  color="primary"
                  type="submit"
                  :loading="loading"
                ) Guardar Cambios
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SiteConfig',
  
  data: () => ({
    success: false,
    showToken: false,
    config: {
      maintenanceMode: false,
      previewToken: '',
      allowedIPs: [],
      subscription: {
        price: 150000,
        billingMode: 'monthly_on_creation_day',
        graceMonths: 1,
        invoiceNotes: ''
      }
    },
    billingModes: [
      { text: 'Mensual en día de creación', value: 'monthly_on_creation_day' },
    ]
  }),

  computed: {
    ...mapState('siteConfig', ['loading'])
  },

  methods: {
    ...mapActions('siteConfig', ['fetchConfig', 'updateConfig']),

    async loadConfig() {
      try {
        const config = await this.fetchConfig();
        // Merge con defaults para evitar undefined
        this.config = {
          ...this.config,
          ...config,
          subscription: {
            ...this.config.subscription,
            ...(config && config.subscription ? config.subscription : {})
          }
        };
      } catch (error) {
        this.$store.dispatch('showError', 'Error al cargar la configuración');
      }
    },

    async saveConfig() {
      try {
        await this.updateConfig(this.config);
        this.success = true;
        setTimeout(() => this.success = false, 3000);
      } catch (error) {
        this.$store.dispatch('showError', 'Error al guardar la configuración');
      }
    }
  },

  created() {
    this.loadConfig();
  }
}
</script>

<style scoped>
.site-config .v-card {
  border-radius: 8px;
}

.site-config .v-card-title {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
</style>
